/* eslint-disable @next/next/no-img-element */
import type { MediaBlock } from "../types";

export function ImageBlock({ mediaUrl, alt }: MediaBlock["config"]) {
  return <>{mediaUrl ? <img src={mediaUrl} alt={alt ?? ""} /> : null}</>;
}
